import * as types from '../actions/types';

const initialState = {
  // Агрегированные настройки (background + emblem)
  settings: null,
  settingsLoading: false,
  bgUploading: false,
  emblemUploading: false,

  // Файлы заставки
  ssFiles: [],
  ssFilesLoading: false,
  ssFileUploading: false,

  // Настройки заставки
  ssSettings: { idle_sec: 300, slide_sec: 10 },
  ssSettingsLoading: false,
};

export default function tvPanel(state = initialState, action) {
  switch (action.type) {
    case types.SET_TV_PANEL_SETTINGS:
      return { ...state, settings: action.payload };
    case types.SET_TV_PANEL_SETTINGS_LOADING:
      return { ...state, settingsLoading: action.payload };
    case types.SET_TV_PANEL_BG_UPLOADING:
      return { ...state, bgUploading: action.payload };
    case types.SET_TV_PANEL_EMBLEM_UPLOADING:
      return { ...state, emblemUploading: action.payload };
    case types.SET_TV_PANEL_SS_FILES:
      return { ...state, ssFiles: action.payload };
    case types.SET_TV_PANEL_SS_FILES_LOADING:
      return { ...state, ssFilesLoading: action.payload };
    case types.SET_TV_PANEL_SS_FILE_UPLOADING:
      return { ...state, ssFileUploading: action.payload };
    case types.SET_TV_PANEL_SS_SETTINGS:
      return { ...state, ssSettings: action.payload };
    case types.SET_TV_PANEL_SS_SETTINGS_LOADING:
      return { ...state, ssSettingsLoading: action.payload };
    default:
      return state;
  }
}
